import React, { useState } from 'react';
import axios from 'axios';
import './AuthStyle.css'; 
import { API_URL } from '../../../redux/consts';
import Cookies from 'js-cookie';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const csrfToken = Cookies.get('csrftoken');
    const response = await axios.post(`${API_URL}/api/forgot-password/`, { email }, {
      headers: {
        'X-CSRFToken': csrfToken,
      },
      
      withCredentials: true
    });
    setMessage(response.data.message);
    setError('');
  } catch (err) {
    setError(err.response.data.error || 'An error occurred. Please try again.');
    setMessage('');
  }
};

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Forgot Password</h2>
        <p className="auth-subtitle">Enter your email to receive a reset link.</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="email"
            className="auth-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="auth-button">Send Reset Link</button>
        </form>
        {message && <p className="auth-message success">{message}</p>}
        {error && <p className="auth-message error">{error}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;